import { ClientSecurityTransaction } from "@models/security-transactions/client-security-transaction";
import { SecurityTransaction } from "@models/security-transactions/security-transaction";
import { SecurityTransactionType } from "@models/security-transactions/security-transaction-type.enum";

export const transactionTypeOrder: SecurityTransactionType[] = [
  SecurityTransactionType.Balance,
  SecurityTransactionType.Issue,
  SecurityTransactionType.TransferFrom,
  SecurityTransactionType.TransferTo,
  SecurityTransactionType.SubdivisionFrom,
  SecurityTransactionType.SubdivisionTo,
  SecurityTransactionType.ConsolidationFrom,
  SecurityTransactionType.ConsolidationTo,
  SecurityTransactionType.ChangeAmountPaidFrom,
  SecurityTransactionType.ChangeAmountPaidTo,
  SecurityTransactionType.ConversionFrom,
  SecurityTransactionType.ConversionTo,
  SecurityTransactionType.Cancellation
];

export function calculateSecurityTransactionsBalance(data: SecurityTransaction[], sumAll = true): ClientSecurityTransaction[] {
  const sortedData = data
    .sort((a, b) => a.transactionDate.getTime() - b.transactionDate.getTime() || a.sequentialNumber - b.sequentialNumber ||
      transactionTypeOrder.indexOf(a.transactionType) - transactionTypeOrder.indexOf(b.transactionType))
    .map((item) => {
      return new ClientSecurityTransaction({
        ...item,
        groupNumberBalance: item.numberIncrease,
        groupPaidBalance: item.paidIncrease,
        groupUnpaidBalance: item.unpaidIncrease,
        numberBalance: item.numberIncrease,
        paidBalance: item.paidIncrease,
        unpaidBalance: item.unpaidIncrease
      });
    });


  //calculate balances for each holding
  const groupedData = sortedData.reduce((acc, item) => {
    const key = item.securityHoldingId!;
    acc[key] = acc[key] || new Array<ClientSecurityTransaction>();
    acc[key].push(item);
    return acc;
  }, {} as Record<string, ClientSecurityTransaction[]>);

  Object.values(groupedData).forEach((group) => {
    group.forEach((item, i) => {
      if (i > 0) {
        if (item.transactionType === SecurityTransactionType.Balance) {
          item.groupNumberBalance = item.numberIncrease;
          item.groupPaidBalance = item.paidIncrease;
          item.groupUnpaidBalance = item.unpaidIncrease;
        } else {
          item.groupNumberBalance = group[i - 1].groupNumberBalance + item.numberIncrease;
          item.groupPaidBalance = group[i - 1].groupPaidBalance + item.paidIncrease;
          item.groupUnpaidBalance = group[i - 1].groupUnpaidBalance + item.unpaidIncrease;
        }
      }
    });
  });

  if (!sumAll) {
    sortedData.forEach((item) => {
      item.numberBalance = item.groupNumberBalance;
      item.paidBalance = item.groupPaidBalance;
      item.unpaidBalance = item.groupUnpaidBalance;
    });
  } else {
    sortedData.forEach((item, i) => {
      if (i > 0) {
        if (item.transactionType === SecurityTransactionType.Balance) {
          const previousHoldingTransaction = sortedData.slice(0, i).reverse()
            .find(x => x.securityHoldingId === item.securityHoldingId);

          if (previousHoldingTransaction) {
            item.numberBalance = sortedData[i - 1].numberBalance + item.numberIncrease - previousHoldingTransaction.groupNumberBalance;
            item.paidBalance = sortedData[i - 1].paidBalance + item.paidIncrease - previousHoldingTransaction.groupPaidBalance;
            item.unpaidBalance = sortedData[i - 1].unpaidBalance + item.unpaidIncrease - previousHoldingTransaction.groupUnpaidBalance;
          } else {
            item.numberBalance = sortedData[i - 1].numberBalance + item.numberIncrease;
            item.paidBalance = sortedData[i - 1].paidBalance + item.paidIncrease;
            item.unpaidBalance = sortedData[i - 1].unpaidBalance + item.unpaidIncrease;
          }
        } else {
          item.numberBalance = sortedData[i - 1].numberBalance + item.numberIncrease;
          item.paidBalance = sortedData[i - 1].paidBalance + item.paidIncrease;
          item.unpaidBalance = sortedData[i - 1].unpaidBalance + item.unpaidIncrease;
        }
      }
    });
  }

  return sortedData.reverse();
}
